import { FORM_VALIDATION_ERROR_MESSAGE } from "renderer/constants";
export var beforeSend = function (event, hint) {
    var IGNORE_ERRORS = [
        'Network Error',
        FORM_VALIDATION_ERROR_MESSAGE,
    ];
    var errorMessage = event.message ||
        (hint.originalException && hint.originalException['message']) ||
        (event.exception && event.exception.values && event.exception.values[0].value);
    // 이슈명을 기준으로 무시
    if (errorMessage && IGNORE_ERRORS.some(function (ignoredMessage) { return errorMessage.includes(ignoredMessage); })) {
        return null; // 무시
    }
    return event; // 수집
};
